import React, { Component } from 'react';
import axios from '../../../axios-ns';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Aux from '../../../hoc/Aux';
import MuiAudioPlayer from '../../AudioPlayer';

class StudentSamples extends Component {
    state = {
        samples: null,
        loading: true,
        open: false
    }

    handleClickOpen = (sampleCode) => {
        this.setState({
            open: true,
            selectedValue: sampleCode
        });
    };

    handleClose = value => {
        axios.get('protected/audio/analysis/samples/CREATED', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(response => {
                this.setState({ ...this.state, samples: response.data, loading: false, open: false });
            }).catch(err => {
                this.setState({ ...this.state, loading: false });
                console.log("error");
            })
    };

    componentDidMount() {
        if (localStorage.getItem('token')) {
            axios.get('protected/audio/analysis/samples/CREATED', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then(response => {
                    this.setState({ samples: response.data, loading: false });
                }).catch(err => {
                    this.setState({ loading: false });
                    console.log("error");
                })
        }
    }

    handleChange = (event, studentSampleCode, field) => {
        let samples = this.state.samples.map(s => {
            if (s.studentSampleCode === studentSampleCode) {
                s[field] = event.target.value;
            }
            return s;
        })
        this.setState({ ...this.state, samples: samples });
    }

    handleSubmit = (event, sampleEvaluation) => {
        event.preventDefault();
        axios.put('protected/samples/' + sampleEvaluation.studentSampleCode, { comment: sampleEvaluation.answer, score: sampleEvaluation.score }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(response => {
                this.handleClose();
            }).catch(err => {
                console.log("Err");
            });
    }

    render() {
        let samples = null;

        if (this.state.samples) {
            if (this.state.samples.length === 0) {
                samples = <p>Brak nowych sampli do oceny</p>
            } else {
                samples = this.state.samples.map(s => {
                    let originalSamples = null;

                    if (s.mediaItems && s.mediaItems.length > 0) {
                        originalSamples = s.mediaItems.map(mi => (<MuiAudioPlayer key={mi.path}
                            onClick={() => {}}
                            src={mi.path}
                        />)
                        )
                    };

                    return (
                        <Card key={s.studentSampleCode} style={{ width: '100%' }}>
                            <CardContent>
                                <b>Originalne ścieżki z nagraniami:</b>
                                {originalSamples}
                                <br />
                                <b>Nagranie ucznia:</b>
                                <MuiAudioPlayer
                                    onClick={() => {}}
                                    src={s.path}
                                />

                                <Card style={{ padding: '10px' }}>
                                    <form onSubmit={(event) => this.handleSubmit(event, s)}>
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            label="Twoja ocena"
                                            multiline
                                            rowsMax="4"
                                            value={s.answer}
                                            onChange={(event) => this.handleChange(event, s.studentSampleCode, 'answer')}
                                            margin="normal"
                                            helperText="Opisz proszę możliwie precyzyjnie swoją odpowiedź."
                                        />
                                        <InputLabel htmlFor="filled-age-simple">Ocena </InputLabel>
                                        <Select
                                            value={s.score}
                                            onChange={(event) => this.handleChange(event, s.studentSampleCode, 'score')}
                                        >
                                            <MenuItem value={0}>0</MenuItem>
                                            <MenuItem value={1}>1</MenuItem>
                                            <MenuItem value={2}>2</MenuItem>
                                            <MenuItem value={3}>3</MenuItem>
                                            <MenuItem value={4}>4</MenuItem>
                                            <MenuItem value={5}>5</MenuItem>
                                        </Select><br/><br/>
                                        <Button variant="outlined" type="submit" color="primary">Wyślij</Button>
                                    </form>
                                </Card>
                            </CardContent>
                        </Card>
                    )
                });
            }
        }

        let view = null;

        if (this.state.loading) {
            view = <Spinner />
        } else {
            view = (<Aux>
                {samples}
            </Aux>);
        }

        return (view);

    };
}

export default StudentSamples;